import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <a href="http://chirag9.com">
        Copyright © 2022 - <span id="c"> Chirag Singh</span>
      </a>
    </footer>
  );
};

export default Footer;
